export default {
    dynamicFormsViewAnswers_title: "Respuestas",
    dynamicFormsViewAnswers_form: "Formulario",
    dynamicFormsViewAnswers_updatedAt: "Actualizado el",
    dynamicFormsViewAnswers_updatedBy: "Actualizado por",
    dynamicFormsViewAnswers_advancedFilters: "Páginas",
    dynamicFormsViewAnswers_imageNotAvailable: "Imagen no disponible",
}